'use strict';

(function () {
  angular
    .module('specsguardApp')
    .factory('Tenant', Tenant);

  Tenant.$inject = ['$resource'];

  function Tenant ($resource) {

    return $resource('/api/tenant/:id/:controller', {
      id: '@_id'
    }, {
      getAllTenants: {
        method: 'GET', isArray: true,
      },
      createTenant: {
        method: 'POST'
      },
      updateTenant: {
        method: 'PUT'
      },
    });
  }

})();
